import { BrowserRouter, Route, Routes } from "react-router-dom";
import Index from "./pages/Dashboard/Index";
import "../src/Assets/styles/style.scss";
import "../src/Assets/styles/Custom.css";
import "../src/Assets/styles/demo.css";
import "antd/dist/antd.min.css";
import CustomerIndex from "./pages/Customers/CustomerIndex";
import config, { axiosInstance } from "./pages/Config";
import CalendarIndex from "./pages/Calendar/CalendarIndex";
import Profile from "./pages/Profile/Profile";
import LessonsIndex from "./pages/Lessions/LessonsIndex"
import { useEffect } from "react";
import secureLocalStorage from "react-secure-storage";
import PageNotFound from './pages/PageNotFound'
import SlotsIndex from "./pages/Availability Slots/SlotsIndex";
import AddSlots from "./pages/Availability Slots/AddSlots";
import Login from "./pages/Account/Login";
import ForgotPassword from "./pages/Account/ForgotPassword";
import ResetPassword from "./pages/Account/ResetPassword";
import './App.css'
import SignUp from "./pages/Account/SignUp";
import SupportIndex from "./pages/Support/SupportIndex";
import ClaimIndex from "./pages/Claim History/ClaimIndex";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CoursesIndex from "./pages/Courses/CoursesIndex";
import ViewCourse from "./pages/Courses/ViewCourse";
import { AppProvider } from "./components/layouts/Appcontext";
import AutoLogout from "./pages/AutoLogout";

function App() {

    return (
        <AppProvider>
            <div className="App">
                <BrowserRouter>
                    <ToastContainer
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="dark"
                    // transition:Bounce,
                    />
                    <Routes>

                        <Route path="*" Component={PageNotFound} />
                        <Route path={`${config.appUrl}login`} Component={Login} />
                        <Route path={`${config.appUrl}sign-up`} Component={SignUp} />
                        <Route path={`${config.appUrl}forgot-password`} Component={ForgotPassword} />
                        <Route path={`${config.appUrl}reset-password`} Component={ResetPassword} />
                        <Route path={`${config.appUrl}`} Component={Index} />

                        <Route path={`${config.appUrl}calendar`} Component={CalendarIndex} />
                        <Route path={`${config.appUrl}students`} Component={CustomerIndex} />
                        <Route path={`${config.appUrl}lessons`} Component={LessonsIndex} />
                        <Route path={`${config.appUrl}profile`} Component={Profile} />
                        <Route path={`${config.appUrl}availability`} Component={SlotsIndex} />
                        <Route path={`${config.appUrl}add-availability-slots/:slot_id/:dayid`} Component={AddSlots} />
                        <Route path={`${config.appUrl}support`} Component={SupportIndex} />
                        .
                        <Route path={`${config.appUrl}claim-history`} Component={ClaimIndex} />
                        <Route path={`${config.appUrl}courses`} Component={CoursesIndex} />
                        <Route path={`${config.appUrl}view-course-details/:id`} Component={ViewCourse} />

                    </Routes>

                    <AutoLogout />

                </BrowserRouter>
            </div>
        </AppProvider>
    );
}

export default App;
